window.ModalVegas = {
	init: ($modal) => {
		let params = $modal.data();

		let option = {
			type:  $modal.data('modal') || 'bootstrap',
			target: $modal.attr('href') || $modal.data('target') || false,
		};

		option = $.extend(option, params);
		ModalVegas.scatter(option);
	},
	scatter: (option) => {
		if (option.target) {
			$.each(option, function (key, value) {
				let $element = $(option.target).find('[data-'+ key +']');

				if ($element.length) {
					let tagName = $element.prop('tagName').toLowerCase();

					if (tagName === 'input' || tagName === 'textarea' || tagName === 'select' || tagName === 'checkbox' || tagName === 'radio') {
						$element.val(value)
					} else {
						$element.html(value)
					}
				}
			});

			if (option.type === 'bootstrap') {
				ModalVegas.modalBootstrap(option);
			} else if(option.type === 'fancybox') {
				ModalVegas.modalFancybox(option);
			}
		}
	},
	modalBootstrap: (option) => {
		$(option.target).modal('show');
	},
	modalFancybox: (option) => {

		console.log('asd')

		/*let defaults = [{
			src: option.target
		}];

		if (option.fancy) {
			defaults[0] = $.extend(option.fancy, defaults[0]);
		}

		$.fancybox.open(defaults);*/
	}
};
